import { render, staticRenderFns } from "./NewTheater.vue?vue&type=template&id=0f0d6ef4&scoped=true"
import script from "./NewTheater.vue?vue&type=script&lang=js"
export * from "./NewTheater.vue?vue&type=script&lang=js"
import style0 from "./NewTheater.vue?vue&type=style&index=0&id=0f0d6ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d6ef4",
  null
  
)

export default component.exports